/*
 *
 * ReinvestigateCases constants
 *
 */

export const DEFAULT_ACTION = "app/ReinvestigateCases/DEFAULT_ACTION";
export const CASEUPDATE = "app/ReinvestigateCases/CASEUPDATE";